/* Local, deterministic portal demonstration. No account or network operations. */
(() => {
  if (window.PCEdgePortal) { window.PCEdgePortal.scan(); return; }
  function init(root) {
    if (root.dataset.ps2Init) return;
    root.dataset.ps2Init = '1';
    const q = s => root.querySelector(s), qa = s => [...root.querySelectorAll(s)];
    const abort = new AbortController(), timers = new Set();
    const on = (el, type, fn) => el.addEventListener(type, fn, { signal: abort.signal });
    const delay = (fn, ms) => { const id = setTimeout(() => { timers.delete(id); fn(); }, ms); timers.add(id); return id; };
    const reduced = () => matchMedia('(prefers-reduced-motion: reduce)').matches || !!root.closest('.is-paused');
    const say = text => { q('[data-ps2-status]').textContent = text; };
    const labels = ['balance', 'equity', 'margin', 'free-margin'];
    const initialLogs = Object.fromEntries(['experts', 'journal'].map(key => [key, q(`[data-ps2-log="${key}"]`).innerHTML]));
    const samples = {
      primary: { name: 'primary-mt5', account: '10203040', status: 'live', values: [10000, 9998.4, 115.25, 9883.15], logs: { ...initialLogs } },
      secondary: { name: 'secondary-mt5', account: '30405060', status: 'live', values: [10000, 10000, 0, 10000], logs: { experts: '', journal: '' } }
    };
    let selected = 'primary', currentTab = 'experts';
    function selectTab(key) {
      currentTab = key;
      qa('[data-ps2-tab]').forEach(t => { const active = t.dataset.ps2Tab === key; t.setAttribute('aria-selected', active); t.tabIndex = active ? 0 : -1; });
      qa('[data-ps2-panel]').forEach(p => { p.hidden = p.dataset.ps2Panel !== key; });
    }
    function render() {
      const item = samples[selected];
      qa('[data-ps2-instance]').forEach(b => {
        const sample = samples[b.dataset.ps2Instance], active = b.dataset.ps2Instance === selected;
        b.setAttribute('aria-pressed', active); b.classList.toggle('ps2-item--dim', !active);
        b.querySelector('.ps2-dot').classList.toggle('is-off', sample.status === 'stopped');
        b.querySelector('.ps2-dot').classList.toggle('is-amber', sample.status === 'restarting');
        b.querySelector('[data-ps2-item-status]').textContent = sample.status === 'live' ? 'Online' : sample.status === 'restarting' ? 'Restarting' : 'Stopped';
        b.dataset.state = sample.status;
      });
      q('[data-ps2-name]').textContent = item.name;
      q('[data-ps2-account]').textContent = `${item.account} · SampleBroker · MT5 · New York · PineConnector EA attached`;
      q('[data-ps2-pill]').classList.toggle('is-off', item.status === 'stopped');
      q('[data-ps2-pill]').classList.toggle('is-warn', item.status === 'restarting');
      q('[data-ps2-pilltx]').textContent = item.status === 'live' ? 'Online' : item.status === 'restarting' ? 'Restarting' : 'Stopped';
      q('[data-ps2-count]').textContent = `${Object.values(samples).filter(s => s.status === 'live').length} active`;
      labels.forEach((label, i) => { q(`[data-ps2-value="${label}"]`).textContent = item.values[i].toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); });
      qa('[data-ps2-ctl]').forEach(b => {
        const disabled = item.status === 'restarting' || (b.dataset.ps2Ctl === 'start' ? item.status === 'live' : item.status === 'stopped');
        // Keep the action in the keyboard sequence as its state changes.
        b.setAttribute('aria-disabled', disabled);
      });
      ['experts', 'journal'].forEach(key => {
        const log = q(`[data-ps2-log="${key}"]`);
        log.innerHTML = item.logs[key] || `<div class="ps2-empty"><b>No ${key === 'experts' ? 'Expert Advisor' : 'journal'} entries yet</b><span>${key === 'experts' ? 'This sample instance is waiting for an instruction.' : 'Try Stop or Restart to see a sample control event.'}</span></div>`;
      });
      q('.ps2-detail').setAttribute('aria-busy', item.status === 'restarting');
      selectTab(currentTab);
    }
    function addLog(key, message) {
      const sample = samples[key], holder = document.createElement('div');
      holder.innerHTML = sample.logs.journal;
      const group = document.createElement('div'); group.className = 'ps2-grp';
      const line = document.createElement('div'); line.className = 'ps2-line'; line.textContent = `Sample control · ${sample.name}: ${message}`;
      group.appendChild(line); holder.appendChild(group);
      while (holder.children.length > 8) holder.firstElementChild.remove();
      sample.logs.journal = holder.innerHTML;
    }
    on(root, 'click', e => {
      const b = e.target.closest('button'); if (!b || !root.contains(b) || b.disabled || b.getAttribute('aria-disabled') === 'true') return;
      if (b.dataset.ps2Instance) { selected = b.dataset.ps2Instance; render(); say(`${samples[selected].name} selected. ${q('[data-ps2-pilltx]').textContent}.`); }
      if (b.dataset.ps2Tab) selectTab(b.dataset.ps2Tab);
      if (b.dataset.ps2Ctl) {
        const key = selected, item = samples[key], action = b.dataset.ps2Ctl;
        currentTab = 'journal';
        item.status = action === 'stop' ? 'stopped' : action === 'restart' ? 'restarting' : 'live';
        addLog(key, action === 'restart' ? 'restart in progress' : action === 'stop' ? 'instance stopped' : 'instance started');
        render(); say(`${item.name}: ${q('[data-ps2-pilltx]').textContent}. Sample only.`);
        q('[data-ps2-log="journal"]').scrollTop = q('[data-ps2-log="journal"]').scrollHeight;
        if (action === 'restart') delay(() => {
          item.status = 'live'; addLog(key, 'restart complete; instance online'); render(); say(`${item.name}: restart complete. Sample only.`);
        }, reduced() ? 0 : 1100);
      }
    });
    on(root, 'keydown', e => {
      const tab = e.target.closest('[data-ps2-tab]'); if (!tab) return;
      const tabs = qa('[data-ps2-tab]'), i = tabs.indexOf(tab);
      const next = e.key === 'ArrowRight' ? (i + 1) % tabs.length : e.key === 'ArrowLeft' ? (i - 1 + tabs.length) % tabs.length : e.key === 'Home' ? 0 : e.key === 'End' ? tabs.length - 1 : null;
      if (next === null) return; e.preventDefault(); selectTab(tabs[next].dataset.ps2Tab); tabs[next].focus();
    });

    const dialog = q('[data-ps2-wiz]');
    let step = 1, connection = '601234567891', opener, setupTimer;
    function setStep(n) {
      step = n;
      qa('[data-ps2-st]').forEach((el, i) => {
        el.classList.toggle('is-on', i === n - 1); el.classList.toggle('is-done', i < n - 1);
        if (i === n - 1) el.setAttribute('aria-current', 'step'); else el.removeAttribute('aria-current');
        el.querySelector('i').textContent = i < n - 1 ? '✓' : i + 1;
      });
      qa('[data-ps2-view]').forEach(v => { v.hidden = Number(v.dataset.ps2View) !== n; });
      q('[data-ps2-wiz-back]').hidden = n !== 2;
      q('[data-ps2-wiz-next]').hidden = n > 2;
      q('[data-ps2-wiz-next]').textContent = n === 1 ? 'Continue' : 'Simulate setup';
      q('[data-ps2-wiz-progress]').textContent = `Step ${n} of 4 · ${['Select connection', 'Configure broker', 'Checking sample connection', 'Sample ready'][n - 1]}`;
      q('[data-ps2-selected-connection]').textContent = connection;
      // Moving a view must never leave focus in hidden content.
      const target = n < 3 ? q('[data-ps2-wiz-next]') : n === 4 ? q('[data-ps2-wiz-done]') : q('[data-ps2-view="3"]');
      target.tabIndex = n === 3 ? -1 : 0; target.focus({ preventScroll: true });
    }
    function closeDialog() {
      clearTimeout(setupTimer); timers.delete(setupTimer);
      dialog.close(); dialog.hidden = true;
      if (opener?.isConnected) opener.focus({ preventScroll: true });
    }
    qa('[data-ps2-add]').forEach(b => on(b, 'click', () => {
      opener = b; dialog.hidden = false; dialog.showModal();
      qa('[data-ps2-type]').forEach(el => { el.textContent = el.dataset.ps2Text; });
      qa('[data-ps2-lic]').forEach(el => { const active = el.dataset.ps2Lic === connection; el.setAttribute('aria-pressed', active); el.classList.toggle('is-on', active); });
      setStep(1);
    }));
    qa('[data-ps2-lic]').forEach(b => on(b, 'click', () => {
      connection = b.dataset.ps2Lic;
      qa('[data-ps2-lic]').forEach(el => { const active = el === b; el.setAttribute('aria-pressed', active); el.classList.toggle('is-on', active); });
    }));
    on(q('[data-ps2-wiz-next]'), 'click', () => {
      if (step === 1) { setStep(2); return; }
      setStep(3);
      setupTimer = delay(() => { if (dialog.open) setStep(4); }, reduced() ? 0 : 1500);
    });
    on(q('[data-ps2-wiz-back]'), 'click', () => setStep(1));
    on(q('[data-ps2-wiz-x]'), 'click', closeDialog);
    on(dialog, 'cancel', e => { e.preventDefault(); closeDialog(); });
    on(dialog, 'keydown', e => {
      if (e.key !== 'Tab') return;
      const items = [...dialog.querySelectorAll('button:not([disabled]),[tabindex="0"]')].filter(el => el.getClientRects().length);
      const first = items[0], last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
    on(q('[data-ps2-wiz-done]'), 'click', () => {
      if (!samples.added) {
        samples.added = { name: 'strategy-two', account: '20304050', status: 'live', values: [10000, 10000, 0, 10000], logs: { experts: '', journal: '' } };
        const card = document.createElement('button'); card.type = 'button'; card.className = 'ps2-item ps2-item--new'; card.dataset.ps2Instance = 'added';
        card.innerHTML = '<span class="ps2-dot" aria-hidden="true"></span><span class="ps2-item-tx"><b>strategy-two</b><em>20304050 · SampleBroker</em></span><b class="ps2-sr" data-ps2-item-status>Online</b>';
        q('[data-ps2-newslot]').appendChild(card);
      }
      qa('[data-ps2-add]').forEach(b => { b.textContent = 'Replay setup'; });
      selected = 'added'; currentTab = 'journal'; addLog('added', 'sample setup complete'); render(); closeDialog(); say('strategy-two added and selected. Demonstration only.');
    });
    qa('[data-ps2-co]').forEach(card => {
      const cls = `ps2-hl-${card.dataset.ps2Co}`;
      on(card, 'mouseenter', () => root.classList.add(cls));
      on(card, 'mouseleave', () => root.classList.remove(cls));
    });
    q('[data-ps2-win]').classList.add('ps2-jsactive');
    qa('[data-ps2-reveal]').forEach(el => el.classList.add('ps2-in'));
    qa('[data-ps2-app]').forEach(el => el.classList.add('is-in'));
    render();
    on(document, 'shopify:section:unload', e => {
      if (!e.target.contains(root)) return;
      if (dialog.open) closeDialog();
      timers.forEach(clearTimeout); abort.abort();
    });
  }
  const scan = (scope = document) => scope.querySelectorAll('.ps2-section').forEach(init);
  window.PCEdgePortal = { scan };
  document.addEventListener('shopify:section:load', e => scan(e.target));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan(), { once: true }); else scan();
})();
